module.exports = __webpack_public_path__ + "img/award.ab6d4ac0.png";